module.exports = __webpack_public_path__ + "img/1.e18dc44a.png";